export const AdminPlaceMapHook: {
  el?: HTMLElement
  abortController?: AbortController
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const rootElement = this.el

    // Read place data from data attributes
    const placeId = rootElement.dataset.placeId
    const coordinatesStr = rootElement.dataset.coordinates

    let coordinates = null
    if (coordinatesStr && coordinatesStr !== 'null') {
      try {
        coordinates = JSON.parse(coordinatesStr)
      } catch (e) {
        console.error('Failed to parse coordinates:', e)
      }
    }

    const placeData = {
      id: placeId || '',
      coordinates: coordinates,
    }

    void import('../../react/views/AdminPlaceMapView')
      .then(({ AdminPlaceMapView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminPlaceMapView({
          rootElement,
          liveView: this,
          placeData: placeData,
        })
      })
      .catch((error) => {
        console.error('[AdminPlaceMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
